import { Switch, SwitchProps } from "@mui/material";
import clsx from "clsx";
import React from "react";
import BriaTooltip from "../BriaTooltip/BriaTooltip";
import LoadingPlaceholder from "../LoadingPlaceholder/LoadingPlaceholder";
import styles from "./BriaSwitch.module.scss";

export interface BriaSwitchProps extends Omit<SwitchProps, "onChange"> {
	checked: boolean;
	labelLeft?: string;
	labelRight?: string;
	onToggle: (checked: boolean) => void;
	labelClassName?: string;
	switchClassName?: string;
	leftLoading?: boolean;
	rightLoading?: boolean;
	disabledTooltip?: string;
}

const BriaSwitch: React.FC<BriaSwitchProps> = ({
	checked,
	labelLeft,
	labelRight,
	onToggle,
	labelClassName,
	switchClassName,
	leftLoading = false,
	rightLoading = false,
	disabledTooltip,
	...rest
}) => {
	const switchComponent = (
		<Switch
			checked={checked}
			className={clsx(styles.switch, switchClassName)}
			onChange={(e) => onToggle(e.target.checked)}
			color="primary"
			{...rest}
		/>
	);

	return (
		<div className={styles.briaSwitchWrapper}>
			{labelLeft && (
				<span
					className={clsx(styles.label, labelClassName, {
						[styles.selected]: !checked,
					})}
				>
					{labelLeft}
					{leftLoading && <LoadingPlaceholder isLoading={leftLoading} size={15} />}
				</span>
			)}

			{rest.disabled && disabledTooltip ? (
				<BriaTooltip title={disabledTooltip} displayOn="hover">
					{switchComponent}
				</BriaTooltip>
			) : (
				switchComponent
			)}

			{labelRight && (
				<span
					className={clsx(styles.label, labelClassName, {
						[styles.selected]: checked,
					})}
				>
					{rightLoading && <LoadingPlaceholder isLoading={rightLoading} size={15} />}
					{labelRight}
				</span>
			)}
		</div>
	);
};

export default BriaSwitch;
